import { mapMutations, mapGetters, mapActions } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "payments-methods",
    data() {
        return {};
    },
    mixins: [dynamicHead],

    components: {
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({
            paymentMethodsList: "paymentMethods/paymentMethodsList",
            paymentMethodsListLoading: "paymentMethods/paymentMethodsListLoading",
            seoData: "setting/seoData",
        }),
    },
    created() {
        this.getSeoData("payment-methods").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.paymentMethodsList) {
            this.fetchPaymentsList();
        }
    },
    methods: {
        ...mapActions({
            fetchPaymentsList: `paymentMethods/GET_PAYMENT_METHODS_LIST`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
